



























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Floor from "../../../store/entities/floor";
class PagefloorRequest{
  ftId:Number;
}
@Component
export default class EditFloor extends AbpBase {
  pagefloorrequest: PagefloorRequest = new PagefloorRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  floor: Floor = new Floor();
  save() {
    (this.$refs.floorForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "floor/update",
          data: this.floor,
        });
        (this.$refs.floorForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.floorForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.floor = Util.extend(true, {}, this.$store.state.floor.editFloor);
      this.floorchange(this.floor.ftId);
    }
  }
  floorRule = {
    ftId: [{ type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{ type:"number",required: true, message: "请选择库房", trigger: "change" }],
    fName: [{ required: true, message: "请填写楼层名称", trigger: "blur" }],
    number: [{transform: (value) => String(value), required: true, message: "请填写楼层编号", trigger: "blur" }],
  };
  get factory() {
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
  floorchange(value:Number){
    this.pagefloorrequest.ftId = value;
    this.getwarehouse();
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.pagefloorrequest,
    });
  }
  created() {}
}
